module.exports = __webpack_public_path__ + "img/4.58b72246.jpg";